import StyleSettingsModule from "./style/styleSettings/styleSettingsModule";
import StylerFactory from "./style/styler/stylerFactory";

import type { ILayerView} from "@esWebAPI/es/model/Layer";
import type StylerModule from "./style/styler/styler";

export default class StyleModule {
    private styler: StylerModule;

    styleSettings: StyleSettingsModule;
    private stylerFactory: StylerFactory;

    constructor(styler: StylerModule) {
        this.styler = styler;

        this.styleSettings = new StyleSettingsModule();
        this.stylerFactory = new StylerFactory();
    }

    buildStyler(layerView: ILayerView): JQueryDeferred<any> {
        return this.stylerFactory.buildStyler(layerView)
    }

    getStyle(styler, style, feature, layerViewInfo) {
        return this.styler.getStyle(styler, style, feature, layerViewInfo);
    }
    
    getPaddingPx(layerView: ILayerView): JQueryDeferred<number[]> {
        return this.stylerFactory.buildStyler(layerView).then((styler) => {
            return this.styler.getPaddingPx(styler);
        });
    }
    
    getRequiredAttributes(styleSettings, territoryModel): string[] {
        return this.styleSettings.getRequiredAttributes(styleSettings, territoryModel);
    }
    
    hasDirect(styler): boolean {
        return this.styler.hasDirect(styler);
    }
    
    hasOverlays(styler): boolean {
        return this.styler.hasOverlays(styler);
    }
    
    circle(ctx: CanvasRenderingContext2D, cx: number, cy: number, radius: number) {
        ctx.beginPath();
        ctx.arc(cx, cy, radius, 0, 2 * Math.PI, false);
        ctx.closePath();
    }
    
    getCentroid(array: number[], startIndex: number, endIndex: number) {
        //es.log.info("getCentroid", startIndex, endIndex);
        let twicearea = 0;
        let x = 0;
        let y = 0;
        let y2 = array[--endIndex];
        let x2 = array[--endIndex];
        while (endIndex > startIndex) {
            let x1 = x2;
            let y1 = y2;
            y2 = array[--endIndex];
            x2 = array[--endIndex];
            const f = (x1 * y2) - (x2 * y1);
            twicearea += f;
            x += (x1 + x2) * f;
            y += (y1 + y2) * f;
        }
        const f = twicearea * 3;
        return [x / f, y / f];
    }
    
    getArea(array: number[], startIndex: number, endIndex: number) {
        let y2 = array[--endIndex];
        let x2 = array[--endIndex];
        let area = 0;
        while (endIndex > startIndex) {
            const y1 = array[--endIndex];
            const x1 = array[--endIndex];
            area += (x1 * y2) - (x2 * y1);
            x2 = x1;
            y2 = y1;
        }
        area /= 2;
        return area;
    }
    
    getHideFeaturesCriteria(styler) {
        return this.styler.getHideFeaturesCriteria(styler);
    }
}
